import React from 'react';
import PropTypes from 'prop-types';
import formValueSelector from 'redux-form/es/formValueSelector';
import { FormattedMessage } from 'react-intl';
import { useApplicationFlags } from 'hooks/useApplicationFlags';
import { useTranslationSuffix } from 'hooks/useTranslationSuffix';
import Loans from './LoansAU';
import UpgradeLoans from './UpgradeLoansAU';

const selector = formValueSelector('loan');

const LoansAU = ({ loanTypes, loanPaymentsFrequencies, formState }) => {
  const { isOcmOrUpgrade } = useApplicationFlags();
  const title = useTranslationSuffix('upgrade', 'loans.title');

  const isFieldSetToYes = (field) => selector(formState, field) === 'yes';

  const upgradeProps = {
    hasLoans: isFieldSetToYes('loanPayments'),
    hasSmallLoans: isFieldSetToYes('smallLoanPayments'),
    hasCreditCards: isFieldSetToYes('creditCards'),
  };

  const defaultProps = {
    hasPayAdvanceLoans: isFieldSetToYes('payAdvancePayments'),
    hasCreditCards: isFieldSetToYes('creditCards'),
    hasSmallLoans: isFieldSetToYes('smallLoanPayments'),
    hasHomeLoans: isFieldSetToYes('homeLoanPayments'),
    hasOtherLoans: isFieldSetToYes('otherLoanPayments'),
  };

  const currentProps = isOcmOrUpgrade ? upgradeProps : defaultProps;

  return (
    <div className="loan-form__step">
      <h1 className="loan-form__step-title">
        <FormattedMessage id={title} />
      </h1>
      {!isOcmOrUpgrade && (
        <p className="loan-form__step-subtitle info block">
          <FormattedMessage id="loans.subtitle" />
        </p>
      )}
      <div className="loan-form__step-body">
        {isOcmOrUpgrade ? (
          <UpgradeLoans
            loanPaymentsFrequencies={loanPaymentsFrequencies}
            loanTypes={loanTypes}
            {...currentProps}
          />
        ) : (
          <Loans
            loanTypes={loanTypes}
            loanPaymentsFrequencies={loanPaymentsFrequencies}
            {...currentProps}
          />
        )}
      </div>
    </div>
  );
};

LoansAU.propTypes = {
  loanPaymentsFrequencies: PropTypes.array.isRequired,
  loanTypes: PropTypes.array.isRequired,
  formState: PropTypes.object.isRequired,
};

export default LoansAU;
